import { Link } from 'react-router-dom';

export default function KnowledgeHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Right decorative image */}
      <div className="absolute top-0 right-0 w-[48%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=open%20book%20reading%20knowledge%20learning%20warm%20library%20desk%20natural%20light%20cozy%20professional%20study%20environment%20minimal%20clean%20aesthetic&width=900&height=700&seq=knohero001&orientation=squarish"
          alt="知識分享 保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/55 to-transparent"></div>
      </div>

      {/* Dot pattern */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(#5C5470 1px, transparent 1px)', backgroundSize: '24px 24px' }}
      ></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-[580px]">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>保險知識中心</span>
          </div>

          {/* H1 */}
          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            知識分享
            <br />
            <span className="text-[#D4A373]">把複雜保險，</span>
            <br />
            說成您聽得懂的生活判斷
          </h1>

          {/* Subtitle */}
          <p
            className="text-[#5C5470]/75 mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            從醫療保險、家庭保障、長期照護、退休規劃到理賠流程，
            用清楚、溫和、專業的方式，陪您做出更安心的選擇。
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#articles-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('articles-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-article-line"></i>
              閱讀最新文章
            </a>
            <Link
              to="/about#health-check-form"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-file-search-line"></i>
              預約保單健檢
            </Link>
          </div>

          {/* Mobile image */}
          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=open%20book%20reading%20knowledge%20learning%20warm%20library%20desk%20natural%20light%20cozy%20professional%20study%20environment%20minimal%20clean%20aesthetic&width=800&height=450&seq=knohero002&orientation=landscape"
              alt="知識分享"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
